export default class extends Error {}
